/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Cloud Platform Packer Artifact Registry
 * API for managing Packer images.
 *
 * The version of the OpenAPI document: 2022-12-02
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { HashicorpCloudPacker20221202CreateBucketBodyToJSON, HashicorpCloudPacker20221202CreateBucketResponseFromJSON, HashicorpCloudPacker20221202CreateBuildBodyToJSON, HashicorpCloudPacker20221202CreateBuildResponseFromJSON, HashicorpCloudPacker20221202CreateChannelBodyToJSON, HashicorpCloudPacker20221202CreateChannelResponseFromJSON, HashicorpCloudPacker20221202CreateIterationBodyToJSON, HashicorpCloudPacker20221202CreateIterationResponseFromJSON, HashicorpCloudPacker20221202CreateRegistryBodyToJSON, HashicorpCloudPacker20221202CreateRegistryResponseFromJSON, HashicorpCloudPacker20221202DeleteRegistryResponseFromJSON, HashicorpCloudPacker20221202GetBucketResponseFromJSON, HashicorpCloudPacker20221202GetBuildResponseFromJSON, HashicorpCloudPacker20221202GetChannelResponseFromJSON, HashicorpCloudPacker20221202GetIterationResponseFromJSON, HashicorpCloudPacker20221202GetRegistryResponseFromJSON, HashicorpCloudPacker20221202GetRegistryTFCRunTaskAPIResponseFromJSON, HashicorpCloudPacker20221202ListBucketAncestryResponseFromJSON, HashicorpCloudPacker20221202ListBucketsResponseFromJSON, HashicorpCloudPacker20221202ListBuildsResponseFromJSON, HashicorpCloudPacker20221202ListChannelHistoryResponseFromJSON, HashicorpCloudPacker20221202ListChannelsResponseFromJSON, HashicorpCloudPacker20221202ListIterationsResponseFromJSON, HashicorpCloudPacker20221202RegenerateTFCRunTaskHmacKeyResponseFromJSON, HashicorpCloudPacker20221202UpdateBucketBodyToJSON, HashicorpCloudPacker20221202UpdateBucketResponseFromJSON, HashicorpCloudPacker20221202UpdateBuildBodyToJSON, HashicorpCloudPacker20221202UpdateBuildResponseFromJSON, HashicorpCloudPacker20221202UpdateChannelBodyToJSON, HashicorpCloudPacker20221202UpdateChannelResponseFromJSON, HashicorpCloudPacker20221202UpdateIterationBodyToJSON, HashicorpCloudPacker20221202UpdateIterationResponseFromJSON, HashicorpCloudPacker20221202UpdateRegistryBodyToJSON, HashicorpCloudPacker20221202UpdateRegistryResponseFromJSON, InlineObjectToJSON, } from '../models';
/**
 *
 */
export class PackerServiceApi extends runtime.BaseAPI {
    /**
     * Creates an image bucket in the HCP Packer registry.
     */
    async packerServiceCreateBucketRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling packerServiceCreateBucket.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling packerServiceCreateBucket.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling packerServiceCreateBucket.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/packer/2022-12-02/organizations/{location.organization_id}/projects/{location.project_id}/images`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudPacker20221202CreateBucketBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudPacker20221202CreateBucketResponseFromJSON(jsonValue));
    }
    /**
     * Creates an image bucket in the HCP Packer registry.
     */
    async packerServiceCreateBucket(requestParameters) {
        const response = await this.packerServiceCreateBucketRaw(requestParameters);
        return await response.value();
    }
    /**
     * Creates an image build in the provided image iteration. It is called once for each \"build source\" in a Packer build run. The request will error if the build for a given cloud provider already exists.
     */
    async packerServiceCreateBuildRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling packerServiceCreateBuild.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling packerServiceCreateBuild.');
        }
        if (requestParameters.bucketSlug === null || requestParameters.bucketSlug === undefined) {
            throw new runtime.RequiredError('bucketSlug', 'Required parameter requestParameters.bucketSlug was null or undefined when calling packerServiceCreateBuild.');
        }
        if (requestParameters.iterationId === null || requestParameters.iterationId === undefined) {
            throw new runtime.RequiredError('iterationId', 'Required parameter requestParameters.iterationId was null or undefined when calling packerServiceCreateBuild.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling packerServiceCreateBuild.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/packer/2022-12-02/organizations/{location.organization_id}/projects/{location.project_id}/images/{bucket_slug}/iterations/{iteration_id}`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"bucket_slug"}}`, encodeURIComponent(String(requestParameters.bucketSlug))).replace(`{${"iteration_id"}}`, encodeURIComponent(String(requestParameters.iterationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudPacker20221202CreateBuildBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudPacker20221202CreateBuildResponseFromJSON(jsonValue));
    }
    /**
     * Creates an image build in the provided image iteration. It is called once for each \"build source\" in a Packer build run. The request will error if the build for a given cloud provider already exists.
     */
    async packerServiceCreateBuild(requestParameters) {
        const response = await this.packerServiceCreateBuildRaw(requestParameters);
        return await response.value();
    }
    /**
     * Creates a channel either empty or assigned to an iteration.
     */
    async packerServiceCreateChannelRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling packerServiceCreateChannel.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling packerServiceCreateChannel.');
        }
        if (requestParameters.bucketSlug === null || requestParameters.bucketSlug === undefined) {
            throw new runtime.RequiredError('bucketSlug', 'Required parameter requestParameters.bucketSlug was null or undefined when calling packerServiceCreateChannel.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling packerServiceCreateChannel.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/packer/2022-12-02/organizations/{location.organization_id}/projects/{location.project_id}/images/{bucket_slug}/channels`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"bucket_slug"}}`, encodeURIComponent(String(requestParameters.bucketSlug))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudPacker20221202CreateChannelBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudPacker20221202CreateChannelResponseFromJSON(jsonValue));
    }
    /**
     * Creates a channel either empty or assigned to an iteration.
     */
    async packerServiceCreateChannel(requestParameters) {
        const response = await this.packerServiceCreateChannelRaw(requestParameters);
        return await response.value();
    }
    /**
     * Creates an empty iteration to be written to. This API is called at the beginning of a new Packer build and does not create individual builds for the iteration.
     */
    async packerServiceCreateIterationRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling packerServiceCreateIteration.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling packerServiceCreateIteration.');
        }
        if (requestParameters.bucketSlug === null || requestParameters.bucketSlug === undefined) {
            throw new runtime.RequiredError('bucketSlug', 'Required parameter requestParameters.bucketSlug was null or undefined when calling packerServiceCreateIteration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling packerServiceCreateIteration.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/packer/2022-12-02/organizations/{location.organization_id}/projects/{location.project_id}/images/{bucket_slug}/iterations`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"bucket_slug"}}`, encodeURIComponent(String(requestParameters.bucketSlug))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudPacker20221202CreateIterationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudPacker20221202CreateIterationResponseFromJSON(jsonValue));
    }
    /**
     * Creates an empty iteration to be written to. This API is called at the beginning of a new Packer build and does not create individual builds for the iteration.
     */
    async packerServiceCreateIteration(requestParameters) {
        const response = await this.packerServiceCreateIterationRaw(requestParameters);
        return await response.value();
    }
    /**
     * Creates a HCP Packer registry and starts billing for it.
     */
    async packerServiceCreateRegistryRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling packerServiceCreateRegistry.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling packerServiceCreateRegistry.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling packerServiceCreateRegistry.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/packer/2022-12-02/organizations/{location.organization_id}/projects/{location.project_id}/registry`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudPacker20221202CreateRegistryBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudPacker20221202CreateRegistryResponseFromJSON(jsonValue));
    }
    /**
     * Creates a HCP Packer registry and starts billing for it.
     */
    async packerServiceCreateRegistry(requestParameters) {
        const response = await this.packerServiceCreateRegistryRaw(requestParameters);
        return await response.value();
    }
    /**
     * Deletes a bucket and all its information, such as iterations and builds.
     */
    async packerServiceDeleteBucketRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling packerServiceDeleteBucket.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling packerServiceDeleteBucket.');
        }
        if (requestParameters.bucketSlug === null || requestParameters.bucketSlug === undefined) {
            throw new runtime.RequiredError('bucketSlug', 'Required parameter requestParameters.bucketSlug was null or undefined when calling packerServiceDeleteBucket.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/packer/2022-12-02/organizations/{location.organization_id}/projects/{location.project_id}/images/{bucket_slug}`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"bucket_slug"}}`, encodeURIComponent(String(requestParameters.bucketSlug))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Deletes a bucket and all its information, such as iterations and builds.
     */
    async packerServiceDeleteBucket(requestParameters) {
        const response = await this.packerServiceDeleteBucketRaw(requestParameters);
        return await response.value();
    }
    /**
     * Deletes a build in the provided iteration.
     */
    async packerServiceDeleteBuildRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling packerServiceDeleteBuild.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling packerServiceDeleteBuild.');
        }
        if (requestParameters.buildId === null || requestParameters.buildId === undefined) {
            throw new runtime.RequiredError('buildId', 'Required parameter requestParameters.buildId was null or undefined when calling packerServiceDeleteBuild.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/packer/2022-12-02/organizations/{location.organization_id}/projects/{location.project_id}/builds/{build_id}`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"build_id"}}`, encodeURIComponent(String(requestParameters.buildId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Deletes a build in the provided iteration.
     */
    async packerServiceDeleteBuild(requestParameters) {
        const response = await this.packerServiceDeleteBuildRaw(requestParameters);
        return await response.value();
    }
    /**
     * Deletes a channel.
     */
    async packerServiceDeleteChannelRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling packerServiceDeleteChannel.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling packerServiceDeleteChannel.');
        }
        if (requestParameters.bucketSlug === null || requestParameters.bucketSlug === undefined) {
            throw new runtime.RequiredError('bucketSlug', 'Required parameter requestParameters.bucketSlug was null or undefined when calling packerServiceDeleteChannel.');
        }
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling packerServiceDeleteChannel.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/packer/2022-12-02/organizations/{location.organization_id}/projects/{location.project_id}/images/{bucket_slug}/channels/{slug}`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"bucket_slug"}}`, encodeURIComponent(String(requestParameters.bucketSlug))).replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Deletes a channel.
     */
    async packerServiceDeleteChannel(requestParameters) {
        const response = await this.packerServiceDeleteChannelRaw(requestParameters);
        return await response.value();
    }
    /**
     * Deletes an iteration and all its information, such as its builds.
     */
    async packerServiceDeleteIterationRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling packerServiceDeleteIteration.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling packerServiceDeleteIteration.');
        }
        if (requestParameters.iterationId === null || requestParameters.iterationId === undefined) {
            throw new runtime.RequiredError('iterationId', 'Required parameter requestParameters.iterationId was null or undefined when calling packerServiceDeleteIteration.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        if (requestParameters.bucketSlug !== undefined) {
            queryParameters['bucket_slug'] = requestParameters.bucketSlug;
        }
        if (requestParameters.rollbackChannels !== undefined) {
            queryParameters['rollback_channels'] = requestParameters.rollbackChannels;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/packer/2022-12-02/organizations/{location.organization_id}/projects/{location.project_id}/iterations/{iteration_id}`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"iteration_id"}}`, encodeURIComponent(String(requestParameters.iterationId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Deletes an iteration and all its information, such as its builds.
     */
    async packerServiceDeleteIteration(requestParameters) {
        const response = await this.packerServiceDeleteIterationRaw(requestParameters);
        return await response.value();
    }
    /**
     * Deactivates an active HCP packer registry. Deactivating a registry will stop any additional billing for the resource. Setting the `hard_delete` param to true will delete the registry and any associated resources from the database.
     */
    async packerServiceDeleteRegistryRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling packerServiceDeleteRegistry.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling packerServiceDeleteRegistry.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        if (requestParameters.hardDelete !== undefined) {
            queryParameters['hard_delete'] = requestParameters.hardDelete;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/packer/2022-12-02/organizations/{location.organization_id}/projects/{location.project_id}/registry`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudPacker20221202DeleteRegistryResponseFromJSON(jsonValue));
    }
    /**
     * Deactivates an active HCP packer registry. Deactivating a registry will stop any additional billing for the resource. Setting the `hard_delete` param to true will delete the registry and any associated resources from the database.
     */
    async packerServiceDeleteRegistry(requestParameters) {
        const response = await this.packerServiceDeleteRegistryRaw(requestParameters);
        return await response.value();
    }
    /**
     * Gets a bucket with its latest completed iteration.
     */
    async packerServiceGetBucketRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling packerServiceGetBucket.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling packerServiceGetBucket.');
        }
        if (requestParameters.bucketSlug === null || requestParameters.bucketSlug === undefined) {
            throw new runtime.RequiredError('bucketSlug', 'Required parameter requestParameters.bucketSlug was null or undefined when calling packerServiceGetBucket.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        if (requestParameters.bucketId !== undefined) {
            queryParameters['bucket_id'] = requestParameters.bucketId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/packer/2022-12-02/organizations/{location.organization_id}/projects/{location.project_id}/images/{bucket_slug}`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"bucket_slug"}}`, encodeURIComponent(String(requestParameters.bucketSlug))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudPacker20221202GetBucketResponseFromJSON(jsonValue));
    }
    /**
     * Gets a bucket with its latest completed iteration.
     */
    async packerServiceGetBucket(requestParameters) {
        const response = await this.packerServiceGetBucketRaw(requestParameters);
        return await response.value();
    }
    /**
     * Gets a build with its list of images.
     */
    async packerServiceGetBuildRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling packerServiceGetBuild.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling packerServiceGetBuild.');
        }
        if (requestParameters.buildId === null || requestParameters.buildId === undefined) {
            throw new runtime.RequiredError('buildId', 'Required parameter requestParameters.buildId was null or undefined when calling packerServiceGetBuild.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/packer/2022-12-02/organizations/{location.organization_id}/projects/{location.project_id}/builds/{build_id}`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"build_id"}}`, encodeURIComponent(String(requestParameters.buildId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudPacker20221202GetBuildResponseFromJSON(jsonValue));
    }
    /**
     * Gets a build with its list of images.
     */
    async packerServiceGetBuild(requestParameters) {
        const response = await this.packerServiceGetBuildRaw(requestParameters);
        return await response.value();
    }
    /**
     * Gets a channel with the iteration that it is currently assigned if any.
     */
    async packerServiceGetChannelRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling packerServiceGetChannel.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling packerServiceGetChannel.');
        }
        if (requestParameters.bucketSlug === null || requestParameters.bucketSlug === undefined) {
            throw new runtime.RequiredError('bucketSlug', 'Required parameter requestParameters.bucketSlug was null or undefined when calling packerServiceGetChannel.');
        }
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling packerServiceGetChannel.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/packer/2022-12-02/organizations/{location.organization_id}/projects/{location.project_id}/images/{bucket_slug}/channels/{slug}`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"bucket_slug"}}`, encodeURIComponent(String(requestParameters.bucketSlug))).replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudPacker20221202GetChannelResponseFromJSON(jsonValue));
    }
    /**
     * Gets a channel with the iteration that it is currently assigned if any.
     */
    async packerServiceGetChannel(requestParameters) {
        const response = await this.packerServiceGetChannelRaw(requestParameters);
        return await response.value();
    }
    /**
     * Allows the user to get an iteration using one of the following identifiers:  * iteration_id  * incremental_version  * fingerprint These are supplied as a query parameter (e.g. `images/{bucket_slug}/iteration?fingerprint={fingerprint}`).
     */
    async packerServiceGetIterationRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling packerServiceGetIteration.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling packerServiceGetIteration.');
        }
        if (requestParameters.bucketSlug === null || requestParameters.bucketSlug === undefined) {
            throw new runtime.RequiredError('bucketSlug', 'Required parameter requestParameters.bucketSlug was null or undefined when calling packerServiceGetIteration.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        if (requestParameters.incrementalVersion !== undefined) {
            queryParameters['incremental_version'] = requestParameters.incrementalVersion;
        }
        if (requestParameters.iterationId !== undefined) {
            queryParameters['iteration_id'] = requestParameters.iterationId;
        }
        if (requestParameters.fingerprint !== undefined) {
            queryParameters['fingerprint'] = requestParameters.fingerprint;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/packer/2022-12-02/organizations/{location.organization_id}/projects/{location.project_id}/images/{bucket_slug}/iteration`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"bucket_slug"}}`, encodeURIComponent(String(requestParameters.bucketSlug))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudPacker20221202GetIterationResponseFromJSON(jsonValue));
    }
    /**
     * Allows the user to get an iteration using one of the following identifiers:  * iteration_id  * incremental_version  * fingerprint These are supplied as a query parameter (e.g. `images/{bucket_slug}/iteration?fingerprint={fingerprint}`).
     */
    async packerServiceGetIteration(requestParameters) {
        const response = await this.packerServiceGetIterationRaw(requestParameters);
        return await response.value();
    }
    /**
     * Gets a HCP Packer registry.
     */
    async packerServiceGetRegistryRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling packerServiceGetRegistry.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling packerServiceGetRegistry.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/packer/2022-12-02/organizations/{location.organization_id}/projects/{location.project_id}/registry`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudPacker20221202GetRegistryResponseFromJSON(jsonValue));
    }
    /**
     * Gets a HCP Packer registry.
     */
    async packerServiceGetRegistry(requestParameters) {
        const response = await this.packerServiceGetRegistryRaw(requestParameters);
        return await response.value();
    }
    /**
     * Gets the HCP Packer registry API URL and HMAC key to integrate with Terraform Cloud as a Run Task.
     */
    async packerServiceGetRegistryTFCRunTaskAPIRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling packerServiceGetRegistryTFCRunTaskAPI.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling packerServiceGetRegistryTFCRunTaskAPI.');
        }
        if (requestParameters.taskType === null || requestParameters.taskType === undefined) {
            throw new runtime.RequiredError('taskType', 'Required parameter requestParameters.taskType was null or undefined when calling packerServiceGetRegistryTFCRunTaskAPI.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/packer/2022-12-02/organizations/{location.organization_id}/projects/{location.project_id}/runtasks/{task_type}`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"task_type"}}`, encodeURIComponent(String(requestParameters.taskType))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudPacker20221202GetRegistryTFCRunTaskAPIResponseFromJSON(jsonValue));
    }
    /**
     * Gets the HCP Packer registry API URL and HMAC key to integrate with Terraform Cloud as a Run Task.
     */
    async packerServiceGetRegistryTFCRunTaskAPI(requestParameters) {
        const response = await this.packerServiceGetRegistryTFCRunTaskAPIRaw(requestParameters);
        return await response.value();
    }
    /**
     * Lists the ancestry relationships for an image bucket. This includes direct source images (parents) and downstream images built directly from the image bucket (children).
     */
    async packerServiceListBucketAncestryRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling packerServiceListBucketAncestry.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling packerServiceListBucketAncestry.');
        }
        if (requestParameters.bucketSlug === null || requestParameters.bucketSlug === undefined) {
            throw new runtime.RequiredError('bucketSlug', 'Required parameter requestParameters.bucketSlug was null or undefined when calling packerServiceListBucketAncestry.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }
        if (requestParameters.channel !== undefined) {
            queryParameters['channel'] = requestParameters.channel;
        }
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.incrementalVersion !== undefined) {
            queryParameters['incremental_version'] = requestParameters.incrementalVersion;
        }
        if (requestParameters.iterationId !== undefined) {
            queryParameters['iteration_id'] = requestParameters.iterationId;
        }
        if (requestParameters.fingerprint !== undefined) {
            queryParameters['fingerprint'] = requestParameters.fingerprint;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/packer/2022-12-02/organizations/{location.organization_id}/projects/{location.project_id}/images/{bucket_slug}/ancestry`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"bucket_slug"}}`, encodeURIComponent(String(requestParameters.bucketSlug))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudPacker20221202ListBucketAncestryResponseFromJSON(jsonValue));
    }
    /**
     * Lists the ancestry relationships for an image bucket. This includes direct source images (parents) and downstream images built directly from the image bucket (children).
     */
    async packerServiceListBucketAncestry(requestParameters) {
        const response = await this.packerServiceListBucketAncestryRaw(requestParameters);
        return await response.value();
    }
    /**
     * Lists every existing bucket in the HCP Packer registry and their last completed iteration.
     */
    async packerServiceListBucketsRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling packerServiceListBuckets.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling packerServiceListBuckets.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.sortingOrderBy) {
            queryParameters['sorting.order_by'] = requestParameters.sortingOrderBy;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/packer/2022-12-02/organizations/{location.organization_id}/projects/{location.project_id}/images`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudPacker20221202ListBucketsResponseFromJSON(jsonValue));
    }
    /**
     * Lists every existing bucket in the HCP Packer registry and their last completed iteration.
     */
    async packerServiceListBuckets(requestParameters) {
        const response = await this.packerServiceListBucketsRaw(requestParameters);
        return await response.value();
    }
    /**
     * Lists every existing build and its images for an iteration.
     */
    async packerServiceListBuildsRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling packerServiceListBuilds.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling packerServiceListBuilds.');
        }
        if (requestParameters.bucketSlug === null || requestParameters.bucketSlug === undefined) {
            throw new runtime.RequiredError('bucketSlug', 'Required parameter requestParameters.bucketSlug was null or undefined when calling packerServiceListBuilds.');
        }
        if (requestParameters.iterationId === null || requestParameters.iterationId === undefined) {
            throw new runtime.RequiredError('iterationId', 'Required parameter requestParameters.iterationId was null or undefined when calling packerServiceListBuilds.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.sortingOrderBy) {
            queryParameters['sorting.order_by'] = requestParameters.sortingOrderBy;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/packer/2022-12-02/organizations/{location.organization_id}/projects/{location.project_id}/images/{bucket_slug}/iterations/{iteration_id}/builds`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"bucket_slug"}}`, encodeURIComponent(String(requestParameters.bucketSlug))).replace(`{${"iteration_id"}}`, encodeURIComponent(String(requestParameters.iterationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudPacker20221202ListBuildsResponseFromJSON(jsonValue));
    }
    /**
     * Lists every existing build and its images for an iteration.
     */
    async packerServiceListBuilds(requestParameters) {
        const response = await this.packerServiceListBuildsRaw(requestParameters);
        return await response.value();
    }
    /**
     * Lists a channel assignment history.
     */
    async packerServiceListChannelHistoryRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling packerServiceListChannelHistory.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling packerServiceListChannelHistory.');
        }
        if (requestParameters.bucketSlug === null || requestParameters.bucketSlug === undefined) {
            throw new runtime.RequiredError('bucketSlug', 'Required parameter requestParameters.bucketSlug was null or undefined when calling packerServiceListChannelHistory.');
        }
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling packerServiceListChannelHistory.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/packer/2022-12-02/organizations/{location.organization_id}/projects/{location.project_id}/images/{bucket_slug}/channels/{slug}/history`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"bucket_slug"}}`, encodeURIComponent(String(requestParameters.bucketSlug))).replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudPacker20221202ListChannelHistoryResponseFromJSON(jsonValue));
    }
    /**
     * Lists a channel assignment history.
     */
    async packerServiceListChannelHistory(requestParameters) {
        const response = await this.packerServiceListChannelHistoryRaw(requestParameters);
        return await response.value();
    }
    /**
     * Lists all channels of a given bucket.
     */
    async packerServiceListChannelsRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling packerServiceListChannels.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling packerServiceListChannels.');
        }
        if (requestParameters.bucketSlug === null || requestParameters.bucketSlug === undefined) {
            throw new runtime.RequiredError('bucketSlug', 'Required parameter requestParameters.bucketSlug was null or undefined when calling packerServiceListChannels.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/packer/2022-12-02/organizations/{location.organization_id}/projects/{location.project_id}/images/{bucket_slug}/channels`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"bucket_slug"}}`, encodeURIComponent(String(requestParameters.bucketSlug))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudPacker20221202ListChannelsResponseFromJSON(jsonValue));
    }
    /**
     * Lists all channels of a given bucket.
     */
    async packerServiceListChannels(requestParameters) {
        const response = await this.packerServiceListChannelsRaw(requestParameters);
        return await response.value();
    }
    /**
     * Lists every existing iteration of a bucket.
     */
    async packerServiceListIterationsRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling packerServiceListIterations.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling packerServiceListIterations.');
        }
        if (requestParameters.bucketSlug === null || requestParameters.bucketSlug === undefined) {
            throw new runtime.RequiredError('bucketSlug', 'Required parameter requestParameters.bucketSlug was null or undefined when calling packerServiceListIterations.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.sortingOrderBy) {
            queryParameters['sorting.order_by'] = requestParameters.sortingOrderBy;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/packer/2022-12-02/organizations/{location.organization_id}/projects/{location.project_id}/images/{bucket_slug}/iterations`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"bucket_slug"}}`, encodeURIComponent(String(requestParameters.bucketSlug))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudPacker20221202ListIterationsResponseFromJSON(jsonValue));
    }
    /**
     * Lists every existing iteration of a bucket.
     */
    async packerServiceListIterations(requestParameters) {
        const response = await this.packerServiceListIterationsRaw(requestParameters);
        return await response.value();
    }
    /**
     * Regenerates the HMAC key used to sign requests from Terraform Cloud to HCP Packer run tasks.
     */
    async packerServiceRegenerateTFCRunTaskHmacKeyRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling packerServiceRegenerateTFCRunTaskHmacKey.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling packerServiceRegenerateTFCRunTaskHmacKey.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling packerServiceRegenerateTFCRunTaskHmacKey.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/packer/2022-12-02/organizations/{location.organization_id}/projects/{location.project_id}/runtasks/hmac`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: InlineObjectToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudPacker20221202RegenerateTFCRunTaskHmacKeyResponseFromJSON(jsonValue));
    }
    /**
     * Regenerates the HMAC key used to sign requests from Terraform Cloud to HCP Packer run tasks.
     */
    async packerServiceRegenerateTFCRunTaskHmacKey(requestParameters) {
        const response = await this.packerServiceRegenerateTFCRunTaskHmacKeyRaw(requestParameters);
        return await response.value();
    }
    /**
     * Updates a bucket\'s information.
     */
    async packerServiceUpdateBucketRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling packerServiceUpdateBucket.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling packerServiceUpdateBucket.');
        }
        if (requestParameters.bucketSlug === null || requestParameters.bucketSlug === undefined) {
            throw new runtime.RequiredError('bucketSlug', 'Required parameter requestParameters.bucketSlug was null or undefined when calling packerServiceUpdateBucket.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling packerServiceUpdateBucket.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/packer/2022-12-02/organizations/{location.organization_id}/projects/{location.project_id}/images/{bucket_slug}`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"bucket_slug"}}`, encodeURIComponent(String(requestParameters.bucketSlug))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudPacker20221202UpdateBucketBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudPacker20221202UpdateBucketResponseFromJSON(jsonValue));
    }
    /**
     * Updates a bucket\'s information.
     */
    async packerServiceUpdateBucket(requestParameters) {
        const response = await this.packerServiceUpdateBucketRaw(requestParameters);
        return await response.value();
    }
    /**
     * Updates an image build. This may be most often used for modifying the status of a currently running build.
     */
    async packerServiceUpdateBuildRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling packerServiceUpdateBuild.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling packerServiceUpdateBuild.');
        }
        if (requestParameters.buildId === null || requestParameters.buildId === undefined) {
            throw new runtime.RequiredError('buildId', 'Required parameter requestParameters.buildId was null or undefined when calling packerServiceUpdateBuild.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling packerServiceUpdateBuild.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/packer/2022-12-02/organizations/{location.organization_id}/projects/{location.project_id}/builds/{build_id}`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"build_id"}}`, encodeURIComponent(String(requestParameters.buildId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudPacker20221202UpdateBuildBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudPacker20221202UpdateBuildResponseFromJSON(jsonValue));
    }
    /**
     * Updates an image build. This may be most often used for modifying the status of a currently running build.
     */
    async packerServiceUpdateBuild(requestParameters) {
        const response = await this.packerServiceUpdateBuildRaw(requestParameters);
        return await response.value();
    }
    /**
     * Updates a channel to clear or point to a new iteration.
     */
    async packerServiceUpdateChannelRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling packerServiceUpdateChannel.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling packerServiceUpdateChannel.');
        }
        if (requestParameters.bucketSlug === null || requestParameters.bucketSlug === undefined) {
            throw new runtime.RequiredError('bucketSlug', 'Required parameter requestParameters.bucketSlug was null or undefined when calling packerServiceUpdateChannel.');
        }
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling packerServiceUpdateChannel.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling packerServiceUpdateChannel.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/packer/2022-12-02/organizations/{location.organization_id}/projects/{location.project_id}/images/{bucket_slug}/channels/{slug}`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"bucket_slug"}}`, encodeURIComponent(String(requestParameters.bucketSlug))).replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudPacker20221202UpdateChannelBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudPacker20221202UpdateChannelResponseFromJSON(jsonValue));
    }
    /**
     * Updates a channel to clear or point to a new iteration.
     */
    async packerServiceUpdateChannel(requestParameters) {
        const response = await this.packerServiceUpdateChannelRaw(requestParameters);
        return await response.value();
    }
    /**
     * This API can be used to revoke, restore, or complete an iteration. Revoking can be done at any time to complete or incomplete iterations, immediately or in the future depending on the passing timestamp. When an iteration is revoked, all its descendants will automatically get revoked unless \'skip_descendants_revocation\' is set. Descendants will get revoked asynchronously to the request. Revoked iterations cannot be updated unless restored. To make build-specific updates for builds within the iteration, use the Update Build endpoint.
     */
    async packerServiceUpdateIterationRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling packerServiceUpdateIteration.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling packerServiceUpdateIteration.');
        }
        if (requestParameters.iterationId === null || requestParameters.iterationId === undefined) {
            throw new runtime.RequiredError('iterationId', 'Required parameter requestParameters.iterationId was null or undefined when calling packerServiceUpdateIteration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling packerServiceUpdateIteration.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/packer/2022-12-02/organizations/{location.organization_id}/projects/{location.project_id}/iterations/{iteration_id}`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"iteration_id"}}`, encodeURIComponent(String(requestParameters.iterationId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudPacker20221202UpdateIterationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudPacker20221202UpdateIterationResponseFromJSON(jsonValue));
    }
    /**
     * This API can be used to revoke, restore, or complete an iteration. Revoking can be done at any time to complete or incomplete iterations, immediately or in the future depending on the passing timestamp. When an iteration is revoked, all its descendants will automatically get revoked unless \'skip_descendants_revocation\' is set. Descendants will get revoked asynchronously to the request. Revoked iterations cannot be updated unless restored. To make build-specific updates for builds within the iteration, use the Update Build endpoint.
     */
    async packerServiceUpdateIteration(requestParameters) {
        const response = await this.packerServiceUpdateIterationRaw(requestParameters);
        return await response.value();
    }
    /**
     * Updates the feature tier of an HCP Packer registry.
     */
    async packerServiceUpdateRegistryRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling packerServiceUpdateRegistry.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling packerServiceUpdateRegistry.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling packerServiceUpdateRegistry.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/packer/2022-12-02/organizations/{location.organization_id}/projects/{location.project_id}/registry`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudPacker20221202UpdateRegistryBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudPacker20221202UpdateRegistryResponseFromJSON(jsonValue));
    }
    /**
     * Updates the feature tier of an HCP Packer registry.
     */
    async packerServiceUpdateRegistry(requestParameters) {
        const response = await this.packerServiceUpdateRegistryRaw(requestParameters);
        return await response.value();
    }
}
